export function sanitizeDiseaseString(inputString: any) {
    // Initialize an array to store sanitized disease names
    const sanitizedDiseases: Array<string> = [];

    if (!inputString) {
        return sanitizedDiseases;
    }
    
    // Split the input string into an array of words
    const wordArray = inputString.split(/[.,_]+/);

    // Remove empty strings and sanitize disease names
    wordArray.forEach((word: string) => {
        // Remove non-alphabetical characters and underscores
        
        const diseaseName = word.trim().replace(/[^a-zA-Z ]/g, "");
        if (diseaseName.length > 0) {
            sanitizedDiseases.push(diseaseName);
        }
    });
    return sanitizedDiseases;
}
